// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The token that provides the identifiers of workspace commands for reuse.
 */
export const IWorkspaceCommands = new Token('@jupyterlab/workspaces:IWorkspaceCommands', 'Provides identifiers of workspace commands.');
/**
 * The token that provides the identifiers of workspace commands for reuse.
 */
export const IWorkspacesModel = new Token('@jupyterlab/workspaces:IWorkspacesModel', 'Provides a model for available workspaces.');
//# sourceMappingURL=tokens.js.map